<template>
  <div>
    <v-data-table
      show-expand
      :headers="headers"
      :items="produtos.content"
      class="elevation-1 mt-5 rounded-card card-shadow"
      :loading="loading"
      :server-items-length="produtos.total"
      @update:options="updateOptions"
      :footer-props="footerOptions"
      no-data-text="Nenhuma cotação encontrada"
      loading-text="Carregando cotações..."
      :options="optionsList"
    >
      <template v-slot:item.descricao="{ item }">
        <px-produto-descricao
          :show-codigo="false"
          :especificacao="item.especificacaoProduto"
          :produto="item.produto"/>&nbsp;
      </template>
      <template v-slot:item.codigo="{ item }">
        <px-situacao-cotacao-icon :situacao="item.situacao"/>
        {{ codigoProduto(item) }}
      </template>
      <template v-slot:item.quantidade="{ item }">
        {{ item.quantidade }} {{ item.unidadeMedida.descricao }}
      </template>
      <template v-slot:item.identificador="{ item }">
        <div>
          <px-situacao-cotacao-icon :situacao="item.cotacao.situacao"/>
          {{ item.cotacao.identificador | truncate(25) }}
          <v-btn v-if="!isRascunho(item)"
                 small icon link target="_blank" :to="linkCotacao(item)">
            <v-icon small>mdi-open-in-new</v-icon>
          </v-btn>
        </div>
      </template>
      <template v-slot:item.comprador.nome="{ item }">
        <px-span-tooltip top :text="comprador(item)"
                         :tooltip="item.cotacao.comprador.pessoa.nome"/>
      </template>
      <template v-slot:item.createdIn="{ item }">
        {{ item.createdIn | date(true) }}
      </template>
      <template v-slot:item.options="{ item }">
        <div class="text-right">
          <px-cotacao-resposta-dialog-view v-if="!isRascunho(item)"
                                           :cotacao-id="item.cotacao.id"/>
        </div>
      </template>
      <template v-slot:expanded-item="{ item }">
        <td :colspan="headers.length">
          <div class="mt-3 mb-3">
            <px-cotacao-resposta-view-produto-fornecedores
              is-modal-view
              :cotacao-produto="item"
              :cotacao-id="item.cotacao.id"
              @change="onChange"/>
          </div>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { SituacaoCotacao } from 'px-business-components';
import CotacaoRespostaViewProdutoFornecedores
  from '@/modules/cotacao/resposta/views/CotacaoRespostaViewProdutoFornecedores.vue';

export default {
  props: {
    produtos: Object,
    default: [],
    loading: Boolean,
    onChangeOptions: {
      type: Function,
      required: true,
    },
    optionsList: Object,
  },
  data() {
    return {
      footerOptions: {
        itemsPerPageOptions: [10, 20, 30, 40, 50],
        itemsPerPageText: 'Linhas por página',
      },
      headers: [
        {
          text: 'Cód produto',
          value: 'codigo',
          sortable: false,
        },
        {
          text: 'Produto',
          value: 'descricao',
          sortable: false,
        },
        {
          text: 'Quantidade',
          value: 'quantidade',
        },
        {
          text: 'Cotação',
          value: 'identificador',
        },
        {
          text: 'Empresa',
          value: 'comprador.nome',
        },
        {
          text: 'Data de entrada',
          value: 'createdIn',
        },
        {
          text: null,
          sortable: false,
          value: 'options',
        },
        {
          text: '',
          value: 'data-table-expand',
        },
      ],
    };
  },
  computed: {
    ...mapGetters('user', ['hasRoleComprador']),
    comprador() {
      return item => Vue.filter('truncate')(item.cotacao.comprador.pessoa.nome, 15);
    },
    codigoProduto() {
      return item => (item.produto ? item.produto.codigo : '-');
    },
    isRascunho() {
      return item => SituacaoCotacao.keys.RASCUNHO.key === item.situacao;
    },
    linkCotacao() {
      return item => `/cotacao/${item.cotacao.id}/respostas`;
    },
  },
  methods: {
    updateOptions(options) {
      this.onChangeOptions(options);
    },
    onChange() {
      this.emitUpdate();
    },
    emitUpdate() {
      this.$emit('update');
    },
    onRemove(item) {
      this.$emit('remove', item);
    },
  },
  components: {
    pxCotacaoRespostaViewProdutoFornecedores: CotacaoRespostaViewProdutoFornecedores,
    pxCotacaoRespostaDialogView: () => import('@/modules/cotacao/resposta/views/modal/CotacaoRespostaDialogView.vue'),
  },
};
</script>
